module.exports = __webpack_public_path__ + "img/dotpay.b78920b.svg";